import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
import collapse from '@alpinejs/collapse'
import nav from './nav'
import thoughtsFilter from './thoughtsFilter'
import rotator from './rotator'
import keywordSearch from './keywordSearch'
import imageScroller from './imageScroller'
import emailSignature from './emailSignature'

window.Alpine = Alpine
Alpine.plugin(focus)
Alpine.plugin(collapse)
Alpine.data('nav', nav)
Alpine.data('thoughtsFilter', thoughtsFilter)
Alpine.data('keywordSearch', keywordSearch)
Alpine.data('rotator', rotator)
Alpine.data('imageScroller', imageScroller)
Alpine.data('emailSignature', emailSignature)
Alpine.start()
